module.exports = __webpack_public_path__ + "static/img/blog_good_1.9d7b771.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/blog_good_1.png
// module id = qhuf
// module chunks = 8